module.exports = __webpack_public_path__ + "static/media/nB1qqubpUg.6849a07b.jpg";